import { render, staticRenderFns } from "./PackageVersions.vue?vue&type=template&id=4ddf550c&scoped=true"
import script from "./PackageVersions.vue?vue&type=script&lang=js"
export * from "./PackageVersions.vue?vue&type=script&lang=js"
import style0 from "./PackageVersions.vue?vue&type=style&index=0&id=4ddf550c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf550c",
  null
  
)

export default component.exports